<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.plan_purchase">
    <div class="banner center" style="max-width:1500px;">
        <div class="row row_header freeze_height" style="border: none;" *ngIf="source && source.content">
            <div class="col-md-3">
                <div *ngIf="businessId" style="float: left;">
                    <button class="button_icon button_icon_color icon_adjust"
                        *ngIf="interactionType != InteractionType.B2B && businessId" (click)="onAction(6)">
                        arrow_back
                    </button>
                    <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                        *ngIf="businessId" (click)="onLoad()">
                        refresh
                    </button>
                </div>
                <span class="en"
                    *ngIf="[PlanPurchaseInvoiceStatus.Generated,PlanPurchaseInvoiceStatus.Refunded].indexOf(source.planPurchaseInvoiceStatus) > -1"
                    [innerHTML]="'&nbsp;' + localService.getCurencyCode() + ' ' + (grandTotal | number:'1.2-2')">
                </span>
                <ngx-select style="width: calc(100% - 100px);float: right;"
                    *ngIf="[PlanPurchaseInvoiceStatus.Draft, PlanPurchaseInvoiceStatus.ToBuy].indexOf(source.planPurchaseInvoiceStatus) > -1  && source.content.items.length > 0"
                    [(ngModel)]="selectedDeductionType" [optionValueField]="'key'" [optionTextField]="'value'"
                    [items]="elligibleDeductionTypeToSelect" [noAutoComplete]="true">
                </ngx-select>
            </div>
            <div class="col-md-4" style="text-align: left;">
                <button type="button"
                    *ngIf="[PlanPurchaseInvoiceStatus.Draft, PlanPurchaseInvoiceStatus.ToBuy].indexOf(source.planPurchaseInvoiceStatus) > -1  && source.content.items.length > 0"
                    class="btn btn-primary" style="margin:5px;"
                    (click)="onAction(5)">{{localService.languageContent.plan_purchase.buy}}
                    <span class="en"
                        [innerHTML]="'&nbsp;' + localService.getCurencyCode() + ' ' + (grandTotal | number:'1.2-2')">
                    </span>
                </button>

                <button type="button"
                    *ngIf="interactionType == InteractionType.B2B && [PlanPurchaseInvoiceStatus.Activated].indexOf(source.planPurchaseInvoiceStatus) > -1  && source.content.items.length > 0"
                    class="btn btn-primary" style="margin:5px;"
                    (click)="onAction(10)">{{localService.languageContent.plan_purchase.generate_invoice}}
                </button>

                <button type="button"
                    *ngIf="interactionType != InteractionType.Business && source.planInteractionType != interactionType && [PlanPurchaseInvoiceStatus.Draft, PlanPurchaseInvoiceStatus.ToBuy].indexOf(source.planPurchaseInvoiceStatus) > -1  && source.content.items.length > 0"
                    class="btn btn-primary" style="margin:5px;"
                    (click)="onAction(9)">{{localService.languageContent.plan_purchase.activate_plans}}
                </button>
            </div>
            <div class="col-md-2">
                <button class="btn btn-primary" style="width:100%" (click)="onAction(8)"
                    *ngIf="interactionType == InteractionType.Bill_PnixSoft && source.planPurchaseInvoiceStatus == PlanPurchaseInvoiceStatus.Generated"
                    [disabled]="!isActivePlanAvailable">
                    <i class="material-icons icon_action">assignment_return</i>
                    <span>{{localService.languageContent.plan_purchase.refund}}</span>
                </button>
                <span style="font-weight: normal;color: red;"
                    *ngIf="source.planPurchaseInvoiceStatus == PlanPurchaseInvoiceStatus.Refunded">{{localService.languageContent.plan_purchase.refunded}}</span>
                <button type="button"
                    *ngIf="source.planPurchaseInvoiceStatus == PlanPurchaseInvoiceStatus.Draft && source.content.items.length > 0 && interactionType == InteractionType.Bill_PnixSoft"
                    class="btn btn-primary" style="margin:5px;"
                    (click)="onAction(4)">{{localService.languageContent.plan_purchase.set_buy}}</button>
                <button type="button"
                    *ngIf="![PlanPurchaseInvoiceStatus.Generated,PlanPurchaseInvoiceStatus.Activated,PlanPurchaseInvoiceStatus.Refunded].includes(source.planPurchaseInvoiceStatus)  && source.content.items.length > 0 && interactionType == InteractionType.Bill_PnixSoft"
                    class="btn btn-primary" style="margin:5px;"
                    (click)="onAction(7)">{{localService.languageContent.plan_purchase.paid}}</button>
            </div>
            <div class="col-md-3" style="text-align: right;">
                <button type="button" class="btn btn-primary" style="margin:5px;"
                    *ngIf="[PlanPurchaseInvoiceStatus.Draft, PlanPurchaseInvoiceStatus.ToBuy].indexOf(source.planPurchaseInvoiceStatus) > -1"
                    (click)="onAction(3)">{{localService.languageContent.plan_purchase.add_plan}}</button>
            </div>
        </div>
        <div class="row row_header freeze_height">
            <div class="col-1">
                {{localService.languageContent.table.action}}
            </div>
            <div class="col-3">
                {{localService.languageContent.plan_purchase.plan_type}}
            </div>
            <div class="col-2">
                {{localService.languageContent.plan_purchase.amount}}
            </div>
            <div class="col-3">
                {{localService.languageContent.plan_purchase.valid_from}}
            </div>
            <div class="col-3">
                {{localService.languageContent.plan_purchase.valid_to}}
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div *ngIf="source && source.content">
                <div class="row styled_row" *ngFor="let item of source.content.items">
                    <div class="col-md-1">
                        <button class="button_icon delete icon_adjust" (click)="onAction(2,item.key)"
                            [disabled]="[PlanPurchaseInvoiceStatus.Cancelled,PlanPurchaseInvoiceStatus.Activated, PlanPurchaseInvoiceStatus.Generated,PlanPurchaseInvoiceStatus.Refunded].indexOf(source.planPurchaseInvoiceStatus) > -1 ? true : item.v11 == '0'"
                            title="{{localService.languageContent.common.delete}}">
                            add_circle_outline
                        </button>
                        &nbsp;&nbsp;
                        <button class="button_icon button_icon_color icon_adjust" (click)="onAction(3,item.key)"
                            title="{{localService.languageContent.plan_purchase.edit_or_view}}">
                            remove_red_eye
                        </button>
                    </div>
                    <div class="col-md-3">
                        <span>
                            <span class="en">{{item.v19}} * </span>
                            {{localService.getText(source.planTypes, item.v3)}}
                        </span>
                    </div>
                    <div class="col-md-2" style="text-align: right;">
                        <span class="en"
                            [innerHTML]="localService.getCurencyCode() + ' ' + (item.v13  | number:'1.2-2')">
                        </span>
                    </div>
                    <div class="col-md-3" style="text-align: right;">
                        <span class="en">
                            {{(!item.v6 || item.v6 == '') ? '-' : (item.v6 | date : 'dd-MMM-yyyy')}}
                        </span>
                    </div>
                    <div class="col-md-3" style="text-align: right;">
                        <span class="en">
                            {{(!item.v7 || item.v7 == '') ? '-' : (item.v7 | date : 'dd-MMM-yyyy')}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-plan-purchase-detail-edit *ngIf="source && source.content" [(isOpenPopup)]="isOpenPlanPurchaseEdit"
        [editId]="selectedKey" [planTypes]="source.planTypes" [interactionType]="interactionType"
        [planInteractionType]="source.planInteractionType" [invoiceId]="invoiceId" [monthlyPlans]="source.monthlyPlans"
        [pricing]="source.pricing" [basicPlanMonths]="source.basicPlanMonths"
        (onClose)="onPlanPurchaseEditClosed($event)" />
    <app-payments [(isShowPayment)]="isShowPayment" [interactionType]="interactionType" [amount]="amountToRecharge" [paidType]="4"
        [businessOrUserId]="businessId" [supportingId]="invoiceId" (onPaymentProccesed)="onPaymentProccesed($event)" />
    <app-otp-container *ngIf="isShowRefundOtpPopup" [IsOtpPopup]="true" (onVerified)="onRefundVerifiedOtp($event)"
        [businessId]="businessId" [otpType]="15" [interactionType]="interactionType"
        (onCancelled)="isShowRefundOtpPopup = false" [additionalData]="additionalData" />
    <app-otp-container *ngIf="isShowBuyPlanOtpPopup" [IsOtpPopup]="true" (onVerified)="onBuyPlanVerifiedOtp($event)"
        [businessId]="businessId" [otpType]="15" [interactionType]="interactionType"
        (onCancelled)="isShowBuyPlanOtpPopup = false" [additionalData]="additionalData" />
</div>